import {type ApiFetch, apiEndpoint} from "@/components/Providers/JWTProvider.tsx";
import type {FeeCategory} from "@/types/FeeCategory";

export const doGetFeeCategories = async (apiFetch: ApiFetch) => {
    const url = new URL("/v1/instructor/fee-categories", apiEndpoint);
    const response = await apiFetch(url.toString());
    return ((await response.json()) as FeeCategory[]).sort((a, b) => a.name.localeCompare(b.name));
};
